<template>
  <v-card id="symptoms-list" class="mb-5">
    <v-card-title>
      Неуточненные диагнозы

      <v-spacer></v-spacer>
    </v-card-title>

    <v-data-table :headers="headers" :items="items" :loading="loading" :options.sync="options" :server-items-length="meta.total">
      <template v-slot:top>
        <v-container fluid>
          <v-row no-gutters justify="space-between">
            <v-col cols="12" sm="3">
              <date-range-picker v-model="filter.date" @input="load" />
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field
                class="pa-0 ma-0"
                label="Поиск"
                append-icon="mdi-magnify"
                single-line
                v-model="search"
                @input="apiSearch"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:item.title="{ item }">
        <span v-if="item.title">{{ item.title }}</span>
        <span v-if="!item.title && item.icd10 && item.icd10.translation">{{ item.icd10.translation.name }}</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-icon class="mr-2" @click="toDisease(item)">
          mdi-arrow-right
        </v-icon>
        <v-icon class="mr-2" @click="editItem(item)">
          mdi-pencil
        </v-icon>
        <v-icon @click="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import throttle from "lodash/throttle";
import { QueryHelper } from "@/services/query-helper";
import DateRangePicker from "@/components/forms/DateRangePicker";
import { mapState } from "vuex";
import { CustomerService } from "@/services/api/customer.service";
import AddSymptom from "@/components/modals/AddSymptom";

export default {
  name: "SymptomsList",
  components: { DateRangePicker },
  data: () => ({
    loading: true,
    options: {},
    search: "",
    filter: {
      date: [],
    },
    headers: [
      { text: "Заболевание", value: "title" },
      { text: "Дата начала", value: "date_start", align: "center" },
      { text: "Дата окончания", value: "date_end", align: "center" },
      { text: "Примечание", value: "details", align: "center", sortable: false },
      { text: "", value: "actions", align: "center", sortable: false },
    ],
  }),

  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },

    ...mapState("symptoms", ["items", "meta"]),
  },

  watch: {
    options: {
      handler() {
        this.load();
      },
      deep: true,
    },
  },

  methods: {
    async load() {
      this.loading = true;

      try {
        const params = {
          search: this.search,
          ...QueryHelper.tableSorting(this.options),
          ...QueryHelper.filter(this.filter),
          ...QueryHelper.pagination(this.options, this.meta.total),
        };

        const response = await this.$http.get(`v1/customers/${this.customerId}/symptoms`, { params }).then(r => r.data);
        this.$store.commit("symptoms/SET_META_TOTAL", response.meta.total);
        this.$store.commit("symptoms/SET_ITEMS", response.data);
      } catch (e) {
        // TODO: Обработать ошибку
        console.error(e);

        this.$store.commit("symptoms/SET_ITEMS", []);
        this.$store.commit("symptoms/SET_META_TOTAL", 0);
      }

      this.loading = false;
    },

    apiSearch: throttle(async function apiSearchHandler() {
      await this.load();
    }, 1000),

    /**
     * @param {SymptomItem} item
     * @return {Promise<void>}
     */
    async editItem(item) {
      const response = await CustomerService.getSymptom(this.customerId, item.id);
      this.$dialog.show(AddSymptom, { model: response, width: 600, persistent: true });
    },

    async deleteItem(item) {
      const title = item.title ? `"${item.title}"` : "";
      const result = await this.$dialog.confirm({
        title: "Удаление симптома",
        text: `Вы подтверждаете удаление симптома ${title}`,
      });

      if (result) {
        this.loading = true;
        await this.$store.dispatch("symptoms/removeItem", item);

        if (this.items.length === 0) {
          await this.load();
        }

        this.loading = false;
      }
    },

    async toDisease(item) {
      this.loading = true;

      try {
        const r = await this.$http.post(`v1/customers/${item.user_id}/symptoms/${item.id}/to-diseases`);

        await this.load();
        this.$notify.showMessage(r.data.message, "success");
      } catch (e) {
        if (e.response) {
          this.$notify.showMessage(e.response.message, "error");
        }
      }

      this.loading = false;
    },
  },
};
</script>

<style scoped></style>
